import React, { createContext, useState, useEffect, useContext } from 'react';

export type Theme = 'orange' | 'dark-orange' | 'light-orange';

export interface ThemeContextProps {
  theme: Theme;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps>({
  theme: 'orange',
  toggleTheme: () => {},
});

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>('orange');

  const toggleTheme = () => {
    setTheme((prevTheme) => {
      if (prevTheme === 'orange') return 'dark-orange';
      if (prevTheme === 'dark-orange') return 'light-orange';
      return 'orange';
    });
  };

  // Apply theme class to body for global styling
  useEffect(() => {
    document.body.className = '';
    document.body.classList.add(`theme-${theme}`);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
